export const FETCH_MANDATES_LIST_REQUEST = 'FETCH_MANDATES_LIST_REQUEST';
export const FETCH_MANDATES_LIST_SUCCESS = 'FETCH_MANDATES_LIST_SUCCESS';
export const FETCH_MANDATES_LIST_ERROR = 'FETCH_MANDATES_LIST_ERROR';

export const FETCH_MANDATE_TRANSACTION_LIST_REQUEST =
    'FETCH_MANDATE_TRANSACTION_LIST_REQUEST';
export const FETCH_MANDATE_TRANSACTION_LIST_ERROR =
    'FETCH_MANDATE_TRANSACTION_LIST_ERROR';
export const FETCH_MANDATE_TRANSACTION_LIST_SUCCESS =
    'FETCH_MANDATE_TRANSACTION_LIST_SUCCESS';

export const UPDATE_MANDATE_STATUS_REQUEST = 'UPDATE_MANDATE_STATUS_REQUEST';
export const UPDATE_MANDATE_STATUS_SUCCESS = 'UPDATE_MANDATE_STATUS_SUCCESS';
export const UPDATE_MANDATE_STATUS_ERROR = 'UPDATE_MANDATE_STATUS_ERROR';

export const RESET_MANDATE_TRANSACTION_LIST_DATA =
    'RESET_MANDATE_TRANSACTION_LIST_DATA';

export const GENERATE_MANDATE_REPORT_REQUEST =
    'GENERATE_MANDATE_REPORT_REQUEST';
export const GENERATE_MANDATE_REPORT_SUCCESS =
    'GENERATE_MANDATE_REPORT_SUCCESS';
export const GENERATE_MANDATE_REPORT_ERROR = 'GENERATE_MANDATE_REPORT_ERROR';
export const GET_ACTIVE_MANDATE_REPORT_REQUEST =
    'GET_ACTIVE_MANDATE_REPORT_REQUEST';
export const GET_ACTIVE_MANDATE_REPORT_SUCCESS =
    'GET_ACTIVE_MANDATE_REPORT_SUCCESS';
export const GET_ACTIVE_MANDATE_REPORT_ERROR =
    'GET_ACTIVE_MANDATE_REPORT_ERROR';
export const DOWNLOAD_MANDATE_REPORT_REQUEST =
    'DOWNLOAD_MANDATE_REPORT_REQUEST';
export const DOWNLOAD_MANDATE_REPORT_SUCCESS =
    'DOWNLOAD_MANDATE_REPORT_SUCCESS';
export const DOWNLOAD_MANDATE_REPORT_ERROR = 'DOWNLOAD_MANDATE_REPORT_ERROR';

export const SHOW_MANDATE_LOADER = 'SHOW_MANDATE_LOADER';
export const HIDE_MANDATE_LOADER = 'HIDE_MANDATE_LOADER';
